import { useTranslations } from "next-intl";

import { Card } from "@/components/ui/Card";
import { Divider } from "@/components/ui/Divider";
import { usePlanCharacteristicsConfig } from "@/config/plan-charecteristics.config";

interface ObjectDetailCharacteristicsProps
  extends React.HTMLAttributes<HTMLDivElement> {
  propertyData: any;
  layoutData: any;
}

const renderCharacteristic = (item: any) => {
  const { Icon, translateValue, value } = item;
  return (
    <li
      key={item.name}
      className={"flex items-center gap-8"}
    >
      <Icon className="w-[2.8rem] h-[2.8rem] text-gray-1100" />
      <p className={"flex flex-col gap-3"}>
        <span className="text-gray-1100 font-medium text-md">
          {translateValue}:
        </span>
        <span className="text-gray-1200 font-bold text-lg">{value}</span>
      </p>
    </li>
  );
};

export const PlanDetailCharacteristics = ({
  propertyData,
  layoutData,
  className,
}: ObjectDetailCharacteristicsProps) => {
  const t = useTranslations();
  const values = usePlanCharacteristicsConfig(propertyData, layoutData);

  if (!values || values.length === 0) {
    return null;
  }

  const firstGroup = values.slice(0, 3);
  const secondGroup = values.slice(3);

  return (
    <section className={className}>
      <h2 className={"object-detail__section-header mb-12"}>
        {t("Characteristics")}
      </h2>
      <Card className={"p-12"}>
        <ul className={"grid grid-cols-1 md:grid-cols-3 gap-8"}>
          {firstGroup.map(renderCharacteristic)}
        </ul>
        {secondGroup.length > 0 && (
          <>
            <Divider className="my-12" />
            <ul className={"grid grid-cols-1 md:grid-cols-3 gap-8"}>
              {secondGroup.map(renderCharacteristic)}
            </ul>
          </>
        )}
      </Card>
    </section>
  );
};
